export interface MaintenanceConfig {
  enabled: boolean;
  message?: string;
  estimatedEndTime?: string;
}

// Get maintenance mode configuration from environment variables
export function getMaintenanceConfig(): MaintenanceConfig {
  const enabled = import.meta.env.VITE_MAINTENANCE_MODE === "true";
  
  if (enabled) {
    return {
      enabled: true,
      message: import.meta.env.VITE_MAINTENANCE_MESSAGE,
      estimatedEndTime: import.meta.env.VITE_MAINTENANCE_END_TIME,
    };
  }

  return {
    enabled: false,
  };
}

// Check if current time is past the estimated end time
export function isMaintenanceExpired(estimatedEndTime?: string): boolean {
  if (!estimatedEndTime) return false;
  
  try {
    const endTime = new Date(estimatedEndTime);
    return new Date() > endTime;
  } catch (e) {
    console.error("Invalid maintenance end time:", e);
    return false;
  }
}